@for (currStep of steps; track currentStep; let index = $index; let isFirst = $first) {
  @if (!isFirst) {
    <svg-icon class="arrow" [src]="'arrow-right'" [stretch]="true"></svg-icon>
  }

  <span class="step" [class.selected-step]="index === currentStep" [class.cursor-pointer]="areStepsClickable" (click)="onStepClick(index)">
    {{ index + 1 }}. {{ currStep | translate }}
  </span>
}
